export default __webpack_public_path__ + "static/media/banner-35.5c5c7794.jpg";